import { resolveAssetPath } from "../../shared/utilities/assets";
import type { SectionRenderProps } from "../renderer/types";

export function GallerySection({ data, copy, onOpenGallery }: SectionRenderProps) {
  if (!data.gallery.enabled) return null;
  const images = data.gallery.images.slice().sort((a, b) => a.order - b.order);
  return (
    <section className="gallery section-inner" id="gallery">
      <div className="section-heading"><p className="eyebrow">{copy.ourMoments}</p><h2 data-editor-section="gallery" data-editor-field="gallery.title">{data.gallery.title}</h2></div>
      {images.length ? (
        <div className="masonry">
          {images.map((image, index) => (
            <button type="button" key={image.id} onClick={() => onOpenGallery(images, index)} data-editor-section="gallery" data-editor-field={`gallery.images.${index}`}>
              <img src={resolveAssetPath(image.url)} alt={image.alt} loading="lazy" />
            </button>
          ))}
        </div>
      ) : <p className="empty-state">{copy.emptyGallery}</p>}
    </section>
  );
}
